import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import DefaultPageWrapper from './../../../components/PageStructure/DefaultPageWrapper/DefaultPageWrapper';

const mapDispatchToProps = dispatch => ({
  goBack: () => dispatch(goBack()),
});

const DefaultPageWrapperContainer = connect(
  null,
  mapDispatchToProps,
)(DefaultPageWrapper);

export default DefaultPageWrapperContainer;
